import { useCallback, useEffect, useState } from "react";
import Pagination from "../../Components/pagination/Pagination";
import { apiGet } from "../../Services/Services";
import { ENDPOINTS } from "../../Services/Endpoints";
export default function AuditLogs() {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch, perPage]);

  const fetchAuditLogs = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        page,
        limit: perPage,
      };
      if (debouncedSearch) params.search = debouncedSearch;

      const data = await apiGet(ENDPOINTS.marketing.activityLogs, { params });

      const list = data?.data?.data ?? [];
      const total = data?.data?.total ?? 0;
      const pages = data?.data?.totalPages ?? Math.max(1, Math.ceil(total / perPage));

      setAuditLogs(list);
      setTotalCount(total);
      setTotalPages(pages);

      if (page > pages) {
        setPage(pages);
      }
    } catch {
      setAuditLogs([]);
      setTotalCount(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  }, [debouncedSearch, page, perPage]);

  useEffect(() => {
    fetchAuditLogs();
  }, [fetchAuditLogs]);

  const safePage = Math.min(page, totalPages);
  const start = totalCount === 0 ? 0 : (safePage - 1) * perPage + 1;
  const end = Math.min(safePage * perPage, totalCount);

  return (
    <div className="card cms-table-card">
      <div className="cms-audit-toolbar">
        <input
          type="search"
          className="form-control cms-audit-search"
          placeholder="Search activity logs..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          aria-label="Search activity logs"
        />
      </div>

      <div className="cms-table-wrap">
        <table className="cms-data-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>User</th>
              <th>Action</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4} style={{ textAlign: "center", color: "#6b7280" }}>
                  Loading audit logs...
                </td>
              </tr>
            ) : auditLogs.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: "center", color: "#6b7280" }}>
                  No audit logs found.
                </td>
              </tr>
            ) : (
              auditLogs.map((log) => (
                <tr key={log.id}>
                  <td className="cms-timestamp">{log.createdAt}</td>
                  <td>{log.user?.firstName}</td>
                  <td>
                    <span className="cms-action-badge">{log.activityType}</span>
                  </td>
                  <td>{log.description}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <Pagination
          variant="full"
          summary={`Showing ${auditLogs.length ? start : 0}-${end} of ${totalCount}`}
          page={safePage}
          totalPages={totalPages}
          totalCount={totalCount}
          perPage={perPage}
          onPageChange={(nextPage) =>
            setPage(Math.max(1, Math.min(nextPage, totalPages)))
          }
          onPerPageChange={(val) => {
            setPerPage(val);
            setPage(1);
          }}
        />
      </div>
    </div>
  );
}